import { render, staticRenderFns } from "./numberstep2.vue?vue&type=template&id=25479ec2&scoped=true&"
import script from "./numberstep2.vue?vue&type=script&lang=js&"
export * from "./numberstep2.vue?vue&type=script&lang=js&"
import style0 from "./numberstep2.vue?vue&type=style&index=0&id=25479ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25479ec2",
  null
  
)

export default component.exports